import styled from "styled-components";

const Columns = styled.div`
  display: flex;
  flex-flow: row wrap;
  gap: ${({ noGap }) => (noGap === true ? 0 : "0.875rem")};
  align-items: stretch;
  width: 100%;
  padding: ${({ padding }) => padding};
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    display: block;
    align-items: unset;
    flex-flow: unset;
    padding-inline: 0;
  }
`;

export default Columns;
